module.exports = __webpack_public_path__ + "static/media/series-create-icon.43dbde24.svg";